import React from 'react'
import { Typography } from '@s4l/ds'
import { IconCreditCard } from '@s4l/icons/IconCreditCard'
import { IconTime } from '@s4l/icons/IconTime'
import { useS4LContext } from '@s4l/react-context'
import { useBanner } from '../hooks'
import type { BannersJSON } from '../types'
import { BANNER_TYPES } from '../types'
import styles from './index.module.css'

interface AnnouncementProps {
  bannersJSON?: BannersJSON
}

function Announcement({ bannersJSON }: Readonly<AnnouncementProps>) {
  const { i18n } = useS4LContext()
  const { bannerInformation } = useBanner({
    bannersJSON,
    bannerType: BANNER_TYPES.ANNOUNCEMENT,
  })

  if (!bannerInformation) return null

  const getSubtitleContent = () => {
    const secondTitle = bannerInformation.title.at(1)

    if (!secondTitle) {
      return (
        <span className={styles.defaultSubtitle}>
          <IconTime size={16} />
          {i18n.formatMessage({ id: 'benefits.the-more-nights' })}
          <span className={styles.spacer} />
          <IconCreditCard size={16} />
          {i18n.formatMessage({ id: 'benefits.you-can-pay-later' })}
        </span>
      )
    }

    return secondTitle.translated
      ? secondTitle.text
      : i18n.formatMessage({ id: secondTitle.text ?? '' })
  }

  return (
    <div
      className={styles.topbar}
      style={{ backgroundColor: bannerInformation.bgColor, color: bannerInformation.titleColor }}
    >
      <div className={styles.titleWrapper}>
        <Typography variant="caption" size="l" as="p" ellipsis>
          {bannerInformation.title.at(0)?.translated
            ? bannerInformation.title.at(0)?.text
            : i18n.formatMessage({ id: bannerInformation.title.at(0)?.text ?? '' })}
        </Typography>
      </div>

      <div className={styles.subtitleWrapper}>
        <Typography variant="caption" size="l" as="p" ellipsis>
          {getSubtitleContent()}
        </Typography>
      </div>
    </div>
  )
}
Announcement.displayName = 'Announcement'
export default Announcement
